import React, { lazy } from 'react';
import { redirect, RouteObject } from 'react-router-dom';

const SelectListingStep = lazy(() => import('./steps/SelectListingStep'));
const ContentStep = lazy(() => import('./steps/ContentStep'));
const ReviewStep = lazy(() => import('./steps/ReviewStep'));

/**
 * Step routes for the Create Post wizard, mounted under
 * /:accountIndex/posts/create in src/view/app.jsx (a sibling of the flex
 * campaign wizard's routes). URL segment = step id.
 */
export const postWizardRoutes = (): RouteObject[] => [
  {
    index: true,
    loader: () => redirect('./select-listing')
  },
  {
    path: 'select-listing',
    element: <SelectListingStep />
  },
  {
    path: 'content',
    element: <ContentStep />
  },
  {
    path: 'review',
    element: <ReviewStep />
  }
];
